import { DownloaderProvider } from '@/core';
import { store } from './store';
import { logger } from './logger';

export const downloaderProvider = new DownloaderProvider(logger);
